module.exports = __webpack_public_path__ + "static-v-shop/1784120487426/img/logo_master.c8bdcd8d.svg";